const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 1.34998,
    y: 1.3501,
    width: 63.3,
    height: 63.3,
    rx: 31.65,
    fill: "white",
    fillOpacity: 0.5,
    style: {
      fill: "white",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.34998,
    y: 1.3501,
    width: 63.3,
    height: 63.3,
    rx: 31.65,
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9355 33.7858C42.3695 33.3518 42.3695 32.6482 41.9355 32.2142L34.863 25.1416C34.429 24.7076 33.7253 24.7076 33.2913 25.1416C32.8573 25.5756 32.8573 26.2793 33.2913 26.7133L39.578 33L33.2913 39.2867C32.8573 39.7207 32.8573 40.4244 33.2913 40.8584C33.7253 41.2924 34.429 41.2924 34.863 40.8584L41.9355 33.7858ZM24.85 34.1113H41.1497V31.8887H24.85V34.1113Z",
    fill: "#281D1B",
    style: {
      fill: "#281D1B",
      fill: "color(display-p3 0.1569 0.1137 0.1059)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBlack);
export default __webpack_public_path__ + "static/media/icon-arrow-black.cb1c92ccdf344e0e56a7a7d8a2eb7f62.svg";
export { ForwardRef as ReactComponent };